<template>
  <nuxt-link
    :id="mobile ? 'mobile-cellar-trigger' : 'cellar-trigger'"
    class="btn-nav-cellar"
    to="/cellar/wines/"
  >
    <template v-if="mobile">
      <img :src="mobileImageSrc" />
      <span>My Cellar</span>
      <AlertBadge />
    </template>
    <template v-else>
      <AlertBadge />
      <span>My Cellar</span>
    </template>
  </nuxt-link>
</template>
<script>
import { mapGetters } from 'vuex'
import { getProductNotifications } from '~/services/notificationServices'
import AlertBadge from '~/components/Header/AlertBell/AlertBadge'

export default {
  name: 'MyCellarBell',
  components: { AlertBadge },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    mobileImageSrc: {
      type: String,
      default: '',
    },
  },
  async fetch() {
    try {
      // Only fetch notifications if we haven't fetched yet
      if (this.notifications.length === 0 && this.$auth.loggedIn) {
        const notifications = await getProductNotifications(this.$axios)
        await this.$store.dispatch('setNotifications', notifications)
      }
    } catch (e) {
      Sentry.captureException(e)
    }
  },
  computed: {
    ...mapGetters([
      'cart',
      'notifications',
      'newProductNotifications',
      'notificationsOpen',
      'notificationsPreviousOpen',
      'notificationBell',
    ]),
  },
}
</script>
